import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataSharingService } from 'shared/services/data-sharing/data-sharing.service';
import { InviteCodeModalComponent } from './invite-code-modal/invite-code-modal.component';
import { MatDialog } from '@angular/material';
import { GroupObject } from 'app/models/group';
import { AlertPopupService } from 'shared/services/SS-Alert/alert-popup.service';
import { GroupService } from 'shared/services/SS-Groups/groups.service';
import { SsInventoryService } from 'shared/services/SS-Inventory/ss-inventory.service';
import { environment } from 'environments/environment';
import { UserService } from 'shared/services/User/user.service';
import Swal from 'sweetalert2';
import { VendorsService } from 'shared/services/SS-vendors/vendors.service';
import {Location} from '@angular/common'; 

declare var mixpanel; 

@Component({
  selector: 'app-new-group',
  templateUrl: './new-group.component.html',
  styleUrls: ['./new-group.component.scss']
})

export class NewGroupComponent implements OnInit {
  groupCode: string;
  loading: boolean;
  groups: any;
  leagues: any;
  imageURL: string = environment.URL_TEAM_IMAGES;
  isWhiteLabel = environment.IS_WHITE_LABEL; 

  HEADER_TEXT = environment.HEADER_TEXT; 

  constructor(
    private router: Router,
    private data: DataSharingService,
    private dialog: MatDialog,
    private gs: GroupService,
    private us: UserService,
    private route: ActivatedRoute,
    private tm: VendorsService,
    private alertService: AlertPopupService,
    private inventoryService: SsInventoryService,
    private location: Location
  ) { }

  ngOnInit() {
    this.data.changeTitle('New Group');
    mixpanel.track("Landed on New Group page", {})
    this.loading = true;
    this.inventoryService.getInventory().subscribe(res => {
      this.leagues = res.products;
      this.loading = false;
    }, err1 => {
      this.loading = false;
      this.alertService.errorAlertWithResult('Failed to fetch Seasons', 'Go Back', '/new-group');
    });

    // MODERN ACCOUNT CALLBACK 
    this.route.queryParams.subscribe(params => {
      console.log("Params", params)
      let code = params.code;
      // alert(code)
      if (params.state.includes('UPLOAD')) {
        // get the team id
        let teamId = params.state.split('-')[1]
        // TO DO Dynamic team id 
        this.tm.connectAccount(code, teamId).subscribe(res => { // hard code remove TODO
          console.log("Conneceted ticketmaster")
          this.location.replaceState("/new-group");
          this.alertService.errorAlertSuccess("Successfully linked your Team Account!")
          this.us.reloadUser().then(res => {
            console.log("updated user", res)
            console.log(this.us.user.team_auths)
            let auths = this.us.user.team_auths
            const account_id = this.us.getTeamAccountID(teamId);
            this.router.navigate(['/new-group/choose-team/upload-plan'], {
              queryParams: {
                acctId: account_id, teamId: teamId
              }
            });

          })
          // this.connectedAccountId = b[1];  
          // this.isTeamAccountConnected = true; 
        }, err => {
          // this.isTeamAccountConnected = false; 
          console.log(err)
          this.alertService.errorAlert("Failed to connect your Team Account. Try again or contact support if the error persists. ")
        })
      }
    });
  }

  joinGroup() {
    const dialogRef = this.dialog.open(InviteCodeModalComponent, {
      width: '400px',
    });
  }

  getSeasonTickets() {
    this.router.navigate(['/new-group/choose-season']);
  }

  uploadExistingTicket() {
    mixpanel.track("Clicked Upload Season Ticket", {})
    if(environment.IS_WHITE_LABEL){
      let teamId = environment.WHITE_LABEL_TEAM_ID; 
      console.log(this.us.user.team_auths)
      console.log(teamId)
      const account_id = this.us.getTeamAccountID(teamId);
      if(account_id){
        this.router.navigate(['/new-group/choose-team/upload-plan'], {
          queryParams: {
            acctId: account_id, teamId: teamId
          }
        });
      } else {
          this.connectTeamAccount(teamId);
      }
    } else {
      // not a white label, choose team selection 
      this.router.navigate(['/new-group/choose-team']);
    }
  }
  //https://auth.ticketmaster.com/archtics/sign-in?client_id=3cd45dd01cc8.seasonshare.integ3-sandbox.us&response_type=&scope=&redirect_uri=http://localhost:4200/new-group?code=3c1b7fd208df52129c1cc52acec85312365d6d31&visualPresets=integ3&lang=en-us&placementId=homepage&integratorId=seasonshare&intSiteToken=tm-us&hideLeftPanel=false&state=UPLOAD-180
  connectTeamAccount(teamId) {
    this.tm.getWidgetUrlByTeamName(teamId).subscribe(res => {
      console.log(res);
      let url = res.url; 
      let replaced = url.replace("REDIRECT_URL", `https://kraken.seasonshare.com/tmcallback/upload`);// redirect back to where we came from, handle in params 
      // let replaced = url.replace("REDIRECT_URL", window.location.href);// redirect back to where we came from, handle in params 
      let finalUrl = replaced.replace("STATE", `UPLOAD-${teamId}`);
      Swal.fire({
        imageUrl: 'assets/images/logos/ticketmaster.png',
        imageWidth: 250,
        imageAlt: 'Custom image',
        title: "Team Account Lookup",
        text: "You will be redirected to Ticketmaster. After signing in, you can share your Season Ticket.",
        showCancelButton: true,
        confirmButtonText: 'Proceed',
        showLoaderOnConfirm: true,
        preConfirm: () => {
          window.open(finalUrl,
            '_self');
        },
        allowOutsideClick: () => !Swal.isLoading()
      }).then((result) => {
      })
    })
  }

  publicGroup() {
    mixpanel.track("Clicked View Open Groups", {})
    if(environment.IS_WHITE_LABEL==true){
      let ID = environment.WHITE_LABEL_TEAM_ID; 
      // this.router.navigate([`/new-group/public-groups?team_id=${ID}`]);
      this.router.navigate(['/new-group/public-groups'],{queryParams: {team_id: ID}})

    } else {
      this.router.navigate(['/new-group/public-groups/choose-team']);
    }
  }


  seeTickets(group: GroupObject) {
    switch (group.group_status) {
      case ('SEAT_RESERVED'):
        this.router.navigate(['/groups/waiting-room'], { queryParams: { groupId: group.group_id } });
        return;
      case ('PENDING_CONFIRM'): {
        this.alertService.errorAlert('Your tickets are processing and will be availalble shortly. Contact support for questions');
        return;
      }
      case ('LOCKED'):
      case ('PENDING_SCHEDULE'):
      case ('SCHEDULED'):
      case ('EXPIRED'):
      case ('OPEN'): {
        this.router.navigate(['/groups/get-ready'], { queryParams: { groupId: group.group_id } });
        return;
      }
      case ('DRAFT'): {
        this.router.navigate(['/draft'], { queryParams: { group_id: group.group_id } });
        return;
      }
      case ('COMPLETE'): {
        /* this.router.navigate(['/groups/get-ready'], { queryParams: { groupId: group.group_id } }); */
        return;
      }
      default:
        this.alertService.errorAlert('An error occured. Please contact support. Error #' + group.group_id + '-721');
    }
  }

  selectTeam(sport) {
    if (sport.vendor_id_fk === '1') {
      this.router.navigate(['/new-group/choose-seats'], { queryParams: { eventName: sport.pk_ss } });
    } else if (sport.vendor_id_fk === '2') {
      // tdc
      this.router.navigate(['/new-group/seat-selection'], { queryParams: { eventName: sport.pk_ss } });
    } else {
      this.alertService.errorAlert('This team is not supported');
    }
  }

  subscriptions(){
    this.router.navigate(['/subscriptions']);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/group/components/new-group/new-group.component.ts